import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { WebApi } from 'app/core/web-api.service';

export interface User {
  accountId: string;
  created: string;
  currency: string;
  email: string;
  firstName: string;
  language: string;
  lastName: string;
  roles: string[];
  timeZoneOffset: string;
  useVerification: boolean;
}

const UserRoles = {
  AccountAdmin: 'account_admin',
  AccountUser: 'account_user',
  NewUser: 'new_user',
  InvitedUser: 'invited_user',
  DeactivatedUser: 'deactivated_user',
  ServiceAdmin: 'service_admin'
};

@Injectable()
export class UserService {

  user: User;

  get userName(): string {
    if (this.user) {
      return `${this.user.firstName || ''} ${this.user.lastName || ''}`.trim() || this.user.email;
    }
  }

  constructor(private _webApi: WebApi) {
  }

  init(): Observable<void> {
    return this._webApi.getOnce('/v1/user').pipe(tap(user => { this.user = user; }));
  }

  isAdmin(): boolean {
    return this._hasRole(UserRoles.AccountAdmin) || this._hasRole(UserRoles.ServiceAdmin);
  }

  isUserServiceAdmin(): boolean {
    return this._hasRole(UserRoles.ServiceAdmin);
  }

  private _hasRole(role: string): boolean {
    return this.user.roles.indexOf(role) >= 0;
  }
}
